import { Component, HostBinding, Input, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import {
  ICONS,
  AppIconName,
} from 'application/src/app/components/common/app-icon/app-icon.icons.generated';

export type { AppIconName };

@Component({
  selector: 'app-icon',
  template: '',
  styles: `
    :host {
      display: inline-flex;
      line-height: 1;
      vertical-align: -0.125em;
    }
  `,
})
export class AppIconComponent {
  private readonly sanitizer = inject(DomSanitizer);

  // The SVG markup is our own bundled asset (see ./icons + icons:generate), not user
  // content — bypassing sanitization here is safe and keeps the paths intact.
  @HostBinding('innerHTML')
  svg: SafeHtml = '';

  @Input({ required: true }) set name(value: AppIconName) {
    this.svg = this.sanitizer.bypassSecurityTrustHtml(ICONS[value]);
  }

  /** Pixel size override; without it the icon follows the surrounding font-size (1em). */
  @HostBinding('style.font-size')
  fontSize: string | null = null;

  @Input() set size(value: number) {
    this.fontSize = value ? `${value}px` : null;
  }
}
